export default __webpack_public_path__ + "static/media/no_data_available.0215408a.svg";